import type { ColumnDefinition } from "@frui.ts/dataviews";
import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import EnforcementTabletsViewModel from "viewModels/enforcement/enforcementTablets/enforcementTabletsViewModel";
import ListView from "../../common/list";
import type EnforcementTabletResponse from "entities/enforcementTabletResponse";
import { translateGeneral } from "utils/localizations";

const TabletsView: ViewComponent<EnforcementTabletsViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<EnforcementTabletResponse>[] = [
    {
      title: vm.translateAttribute("hostname"),
      property: "hostname",
    },
    {
      title: vm.translateAttribute("alias"),
      property: "alias",
    },
    {
      title: vm.translateAttribute("isEnabled"),
      property: "isEnabled",
      valueFormatter: props => translateGeneral(`boolean.${props.value ? "true" : "false"}`),
    },
  ];

  return <ListView vm={vm} columns={columns} />;
});

registerView(TabletsView, EnforcementTabletsViewModel);
